import { render, staticRenderFns } from "./convite.vue?vue&type=template&id=3994a9e4"
import script from "./convite.vue?vue&type=script&lang=js"
export * from "./convite.vue?vue&type=script&lang=js"
import style0 from "./convite.vue?vue&type=style&index=0&id=3994a9e4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports